import { saveAs } from 'file-saver';
import { Link } from 'react-router-dom';
import { GovIcon } from '@gov-design-system-ce/react';
import type { OsobyFotoDto } from '@gov-nx/api';
import {
	useConfiguration,
	useTranslationWithNamespace,
} from '@gov-nx/core/service';
import type { Nullable } from '@gov-nx/core/types';
import type { PageCode } from '@gov-nx/module/page';
import { Button, LayoutGap } from '@gov-nx/ui/web';

export interface ComplaintProps {
	code: PageCode;
	photo: Nullable<OsobyFotoDto['data']>;
}

export const ChangePhotoView = ({ code, photo }: ComplaintProps) => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const { jakVymenitObcankuUrl } = useConfiguration();
	const ts = getLocalizeCurried(code);

	return (
		<div className="flex flex-col gap-6 [ md:flex-row ]">
			{photo ? (
				<img
					src={`data:image/png;base64, ${photo}`}
					alt=""
					width={300}
					height={300}
				/>
			) : null}
			<LayoutGap gap="m">
				<h3 className="text-headline-s!">{ts('foto.neni-aktualni')}</h3>
				<p>{ts('foto.aktualizace-fotky')}</p>
				<div className="flex flex-col gap-4">
					<Button
						asChild
						type="base"
						color="primary"
						size="m"
						iconEnd={<GovIcon name="box-arrow-up-right" />}
						aria-label={ts('foto.vymenit-obcanku')}>
						<Link
							to={jakVymenitObcankuUrl}
							target="_blank">
							{ts('foto.vymenit-obcanku')}
						</Link>
					</Button>
					{photo ? (
						<Button
							onClick={() => saveAs(`data:image/png;base64, ${photo}`)}
							color="primary"
							type="base"
							size="m"
							iconStart={
								<GovIcon
									name="download"
									type="templates"
								/>
							}>
							{ts('foto.stahnout')}
						</Button>
					) : null}
				</div>
			</LayoutGap>
		</div>
	);
};
